module.exports = __webpack_public_path__ + "static/media/close-image.6f6fa773.svg";